// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.94.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reset-password-container {
  position: relative;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
}
.reset-password-container .logo {
  z-index: 1000;
  position: relative;
  padding: 0px 55px;
}
.reset-password-container .ant-row {
  justify-content: center;
}
.reset-password-container .username-reset-password {
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #000000;
  margin-bottom: 20px;
}
.reset-password-container .reset-password-form {
  position: relative;
  background: rgba(255, 255, 255, 0.96);
}
.reset-password-container .reset-password-form .verCode-style {
  display: flex;
  align-items: flex-end;
}
.reset-password-container .reset-password-form .verCode-style .verCode-form-item {
  flex: 1;
}
.reset-password-container .reset-password-form .verCode-style .verCode-button-item {
  margin: 0 5px 25px;
}
.reset-password-container .reset-password-form .more-message {
  text-align: center;
}
.reset-password-container .reset-password-form .more-message a {
  color: #454545;
  padding: 0px 5px;
}
.reset-password-container .reset-password-form .more-message a:hover {
  color: #454545;
}
@media (min-width: 0) and (max-width: 640px) {
  .reset-password-container .logo-box {
    padding: 0px 20px;
    margin-top: 15px;
  }
  .reset-password-container .reset-password-form {
    width: 80%;
    height: auto;
    padding: 5px 15px;
    max-width: 100%;
    margin: 0px auto 0px;
  }
}
@media (min-width: 640px) {
  .reset-password-container .logo-box {
    padding: 0px 55px;
    margin-top: 15px;
  }
  .reset-password-container .reset-password-form {
    width: 30%;
    min-width: 400px;
    margin: auto;
    padding: 10px 15px 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Login/Components/ResetPassword/index.less"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;AACF;AALA;EAMI,aAAA;EACA,kBAAA;EACA,iBAAA;AAEJ;AAVA;EAWI,uBAAA;AAEJ;AAbA;EAcI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AAEJ;AApBA;EAqBI,kBAAA;EACA,qCAAA;AAEJ;AAxBA;EAwBM,aAAA;EACA,qBAAA;AAGN;AA5BA;EA2BQ,OAAA;AAIR;AA/BA;EA8BQ,kBAAA;AAIR;AAlCA;EAkCM,kBAAA;AAGN;AArCA;EAoCQ,cAAA;EACA,gBAAA;AAIR;AAHQ;EACE,cAAA;AAKV;AAEA;EACE;IAEI,iBAAA;IACA,gBAAA;EADJ;EAFA;IAMI,UAAA;IACA,YAAA;IACA,iBAAA;IACA,eAAA;IACA,oBAAA;EADJ;AACF;AAKA;EACE;IAEI,iBAAA;IACA,gBAAA;EAJJ;EACA;IAMI,UAAA;IACA,gBAAA;IACA,YAAA;IACA,uBAAA;EAJJ;AACF","sourcesContent":[".reset-password-container {\n  position: relative;\n  min-height: 100vh;\n  max-width: 100vw;\n  overflow-x: hidden;\n  .logo {\n    z-index: 1000;\n    position: relative;\n    padding: 0px 55px;\n  }\n  .ant-row {\n    justify-content: center;\n  }\n  .username-reset-password {\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n    color: #000000;\n    margin-bottom: 20px;\n  }\n  .reset-password-form {\n    position: relative;\n    background: rgba(255, 255, 255, 0.96);\n    .verCode-style {\n      display: flex;\n      align-items: flex-end;\n      .verCode-form-item {\n        flex: 1;\n      }\n      .verCode-button-item {\n        margin: 0 5px 25px;\n      }\n    }\n    .more-message {\n      text-align: center;\n      a {\n        color: #454545;\n        padding: 0px 5px;\n        &:hover {\n          color: #454545;\n        }\n      }\n    }\n  }\n}\n\n@media (min-width: 0) and (max-width: 640px) {\n  .reset-password-container {\n    .logo-box {\n      padding: 0px 20px;\n      margin-top: 15px;\n    }\n    .reset-password-form {\n      width: 80%;\n      height: auto;\n      padding: 5px 15px;\n      max-width: 100%;\n      margin: 0px auto 0px;\n    }\n  }\n}\n\n@media (min-width: 640px) {\n  .reset-password-container {\n    .logo-box {\n      padding: 0px 55px;\n      margin-top: 15px;\n    }\n    .reset-password-form {\n      width: 30%;\n      min-width: 400px;\n      margin: auto;\n      padding: 10px 15px 10px;\n    }\n  }\n}\n\n@primary-color: #FABF00;@input-placeholder-color: #868686;@btn-primary-color: #454545;@checkbox-check-color: #454545;@checkbox-color: #E8AA0D;@radio-button-bg: #E8AA0D;@radio-button-checked-bg: #E8AA0D;@radio-button-color: #454545;@radio-button-active-color: #454545;@radio-solid-checked-color: #454545;@font-family: 'WenQuanYi Micro Hei', 'Micro Hei','Noto Sans CJK','Source Han Sans','Montserrat','Roboto','Lato','sans-serif';@btn-text-shadow: 0 0 0 rgba(0, 0, 0, 0);"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
